import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthGuardService } from "../services/auth-guard.service";
import { NgModule } from "@angular/core";




const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./pages/onboarding/onboarding.module").then(
        (m) => m.OnboardingPageModule
      ),
  },
  {
    path: "cart",
    loadChildren:() =>
    import("./pages/cart/cart.module").then((m) => m.CartModule),
  },
  {
    path: "login",
    loadChildren: () =>
      import("./pages/login/login.module").then((m) => m.LoginPageModule),
  },

  {
    path: "category/:id",
    loadChildren: () =>
      import("./pages/category/category.module").then(
        (m) => m.CategoryPageModule
      ),
  },
  {
    path: "home",
    loadChildren: () =>
      import("./pages/home/home.module").then((m) => m.HomePageModule),
  },
/////////////nick////////////
//   { path: "login", loadChildren: "./pages/login/login.module#LoginPageModule" },
//   {
//     path: "inside",
//     loadChildren: "./pages/inside/inside.module#InsidePageModule",
//     canActivate: [AuthGuardService],
//   },
];
@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
